import type { ShouldRevalidateFunction } from '@remix-run/react';
import {
    API_ACTIONS,
    DESIGN_BOARD_REMIX_API,
} from '~/modules/design-board/config';

export const doNotRevalidateAfterUpload: ShouldRevalidateFunction = ({
    formAction,
    formData,
}) => {
    const action = formData?.get('_action') as string;
    if (
        formAction?.includes(DESIGN_BOARD_REMIX_API) &&
        action === API_ACTIONS.UPLOAD_DESIGN_BOARD_PIN
    ) {
        return false;
    }

    return true;
};
